export default __webpack_public_path__ + "static/media/aws.cc38dbe9.svg";